export const MATERIAL_LABELS = {
    DONATE: 'donate',
    SALE: 'sale',
    BESTSELLER: 'bestseller',
    HIGH_QUALITY: 'highQuality',
    NEW: 'new'
} as const;

export type MaterialLabel = (typeof MATERIAL_LABELS)[keyof typeof MATERIAL_LABELS] | '';
